import type { ReactNode } from "react";
import {
  FaAppleAlt,
  FaCalendarAlt,
  FaFire,
  FaGift,
  FaLeaf,
  FaLightbulb,
  FaSeedling,
  FaShieldAlt,
  FaSpa,
  FaStar,
  FaSun,
  FaTree,
  FaUsers,
} from "react-icons/fa";

export const suggestedActivityIconKey = (name: string) => {
  const normalized = name.toLocaleLowerCase();
  if (normalized.includes("maria lichtmis") || normalized.includes("lichtmis") || normalized.includes("candlemas")) return "candle";
  if (normalized.includes("michael") || normalized.includes("michaël") || normalized.includes("michaelsfeest") || normalized.includes("michaëlsfeest")) return "shield";
  if (normalized.includes("sint maarten") || normalized.includes("sint-maarten") || normalized.includes("martinus")) return "lantern";
  if (normalized.includes("advent")) return "candle";
  if (normalized.includes("kerst") || normalized.includes("christmas")) return "tree";
  if (normalized.includes("driekoningen") || normalized.includes("epiphany")) return "star";
  if (normalized.includes("pasen") || normalized.includes("paas") || normalized.includes("easter")) return "seedling";
  if (normalized.includes("pinkster") || normalized.includes("pentecost")) return "flower";
  if (normalized.includes("sint-jan") || normalized.includes("sint jan") || normalized.includes("zomer") || normalized.includes("midsummer")) return "sun";
  if (normalized.includes("oogst") || normalized.includes("harvest")) return "harvest";
  if (normalized.includes("sinterklaas") || normalized.includes("sint nicolaas") || normalized.includes("saint nicholas")) return "gift";
  if (normalized.includes("open dag") || normalized.includes("open school")) return "users";
  if (normalized.includes("natuur") || normalized.includes("bos")) return "leaf";
  return "calendar";
};

const activityIcons: Record<string, ReactNode> = {
  candle: <FaFire />,
  shield: <FaShieldAlt />,
  lantern: <FaLightbulb />,
  star: <FaStar />,
  tree: <FaTree />,
  seedling: <FaSeedling />,
  flower: <FaSpa />,
  sun: <FaSun />,
  harvest: <FaAppleAlt />,
  gift: <FaGift />,
  users: <FaUsers />,
  leaf: <FaLeaf />,
  calendar: <FaCalendarAlt />,
};

export const getActivityVisual = (name: string) => {
  const key = suggestedActivityIconKey(name);
  const tone = key === "sun" || key === "harvest" || key === "lantern" ? "text-amber-600 bg-amber-50 dark:bg-amber-950/40"
    : key === "tree" || key === "seedling" || key === "leaf" ? "text-emerald-600 bg-emerald-50 dark:bg-emerald-950/40"
    : key === "candle" || key === "gift" ? "text-rose-500 bg-rose-50 dark:bg-rose-950/40"
    : "text-indigo-600 bg-indigo-50 dark:bg-indigo-950/40";
  return { key, icon: activityIcons[key] || activityIcons.calendar, tone };
};

export const formatClassroomNames = (ids: string[], classroomMap: Map<string, string>) => {
  const names = ids.map((id) => classroomMap.get(id) || id);
  const grades = names.map((name) => name.match(/^Klas\s+(\d+)$/i)?.[1]);
  if (names.length > 1 && grades.every(Boolean)) return `Klas ${grades.join(", ")}`;
  return names.join(", ");
};
